import script from "./ThreadEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThreadEdit.vue?vue&type=script&setup=true&lang=ts"

import "./ThreadEdit.vue?vue&type=style&index=0&id=3023eb79&lang=scss"

const __exports__ = script;

export default __exports__